<nav
  class="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top"
>
  <div class="container-fluid">
    <button
      mat-raised-button
      class="navbar-toggler"
      type="button"
      (click)="sidebarToggle()"
    >
      <span class="sr-only">Toggle navigation</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-start" id="navigation">
      <form class="navbar-form">
        <div class="input-group no-border">
          <input
            type="text"
            value=""
            class="form-control"
            placeholder="Search..."
          />
          <button
            mat-raised-button
            type="submit"
            class="btn btn-white btn-round btn-just-icon"
          >
            <i class="material-icons">search</i>
            <div class="ripple-container"></div>
          </button>
        </div>
      </form>
      <ul class="navbar-nav">
        <li class="nav-item">
          <button type="button" class="nav-link theme-nav-link" (click)="theme.toggle()"
            [attr.aria-label]="theme.toggleLabel" [attr.title]="theme.toggleLabel"
            [attr.aria-pressed]="theme.isDark">
            <i class="material-icons" aria-hidden="true">{{ theme.isDark ? 'light_mode' : 'dark_mode' }}</i>
          </button>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link"
            href="javascript:void(0)"
            id="navbarDropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="material-icons">notifications</i>
            <span class="notification">5</span>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="navbarDropdownMenuLink"
          >
            <a class="dropdown-item" href="javascript:void(0)"
              >Mike John responded to your email</a
            >
            <a class="dropdown-item" href="javascript:void(0)"
              >You have 5 new tasks</a
            >
            <a class="dropdown-item" href="javascript:void(0)"
              >You're now friend with Andrew</a
            >
            <a class="dropdown-item" href="javascript:void(0)"
              >Another Notification</a
            >
            <a class="dropdown-item" href="javascript:void(0)">Another One</a>
          </div>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link"
            href="javascript:void(0)"
            id="navbarDropdownPersonLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="material-icons">person</i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="navbarDropdownPersonLink"
          >
            <a
              class="dropdown-item"
              href="javascript:void(0)"
              (click)="logout()"
              >خروج</a
            >
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link notes-nav-link" routerLink="/stickyNote" routerLinkActive="notes-nav-active" ariaCurrentWhenActive="page">
            <i class="material-icons" aria-hidden="true">note</i>
            <span>Notes</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="navbar-wrapper">
      <button type="button" class="nav-link theme-nav-link theme-mobile-toggle" (click)="theme.toggle()"
        [attr.aria-label]="theme.toggleLabel" [attr.title]="theme.toggleLabel"
        [attr.aria-pressed]="theme.isDark">
        <i class="material-icons" aria-hidden="true">{{ theme.isDark ? 'light_mode' : 'dark_mode' }}</i>
      </button>
      <a class="nav-link notes-mobile-link" routerLink="/stickyNote" routerLinkActive="notes-nav-active" ariaCurrentWhenActive="page">
        <i class="material-icons" aria-hidden="true">note</i><span>Notes</span>
      </a>
      <a class="navbar-brand" href="javascript:void(0)">{{ getTitle() }}</a>
    </div>
  </div>
</nav>

<!--

<nav class="navbar navbar-transparent navbar-absolute">
    <div class="container-fluid">
        <div class="navbar-header">
            <button mat-raised-button type="button" class="navbar-toggle" data-toggle="collapse" (click)="sidebarToggle()">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" href="javascript:void(0)">{{getTitle()}}</a>
        </div>
        <div class="collapse navbar-collapse">
            <ul class="nav navbar-nav navbar-right">
                <li>
                    <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
                        <i class="material-icons">dashboard</i>
                        <p class="hidden-lg hidden-md">Dashboard</p>
                    </a>
                </li>
                <li class="dropdown">
                    <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
                        <i class="material-icons">notifications</i>
                        <span class="notification">5</span>
                        <p class="hidden-lg hidden-md">Notifications</p>
                    </a>
                    <ul class="dropdown-menu">
                        <li><a href="javascript:void(0)">Mike John responded to your email</a></li>
                        <li><a href="javascript:void(0)">You have 5 new tasks</a></li>
                        <li><a href="javascript:void(0)">You're now friend with Andrew</a></li>
                        <li><a href="javascript:void(0)">Another Notification</a></li>
                        <li><a href="javascript:void(0)">Another One</a></li>
                    </ul>
                </li>
                <li>
                    <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">
                       <i class="material-icons">person</i>
                       <p class="hidden-lg hidden-md">Profile</p>
                    </a>
                </li>
            </ul>

            <form class="navbar-form navbar-right" role="search">
                <div class="form-group form-black is-empty">
                    <input type="text" class="form-control" placeholder="Search">
                    <span class="material-input"></span>
                </div>
                <button mat-raised-button type="submit" class="btn btn-white btn-round btn-just-icon">
                    <i class="material-icons">search</i><div class="ripple-container"></div>
                </button>
            </form>
        </div>
    </div>
</nav> -->
